import { useMemo, useState } from "react";
import DataTable from "@/components/DataTable";
import { DELIMITERS, detectDelimiter, isNumeric, parseCsv } from "@/lib/csv";

export default function CsvTable({ text, truncated }: { text: string; truncated: boolean }) {
  const [delimiter, setDelimiter] = useState<string | null>(null);
  const [header, setHeader] = useState<boolean | null>(null);

  const detected = useMemo(() => detectDelimiter(text), [text]);
  const used = delimiter ?? detected;
  const parsed = useMemo(() => {
    const rows = parseCsv(text, used);
    if (truncated) rows.pop(); // cut off in the middle
    return rows;
  }, [text, used, truncated]);
  const hasHeader = header ?? (parsed.length > 1 && !parsed[0].some(isNumeric));
  const names = useMemo(() => (hasHeader ? parsed[0] : []), [parsed, hasHeader]);
  const body = useMemo(() => (hasHeader ? parsed.slice(1) : parsed), [parsed, hasHeader]);

  return (
    <DataTable key={`${used}${hasHeader}`} names={names} body={body} emptyText="This file is empty.">
      <label className="flex items-center gap-1">
        <input type="checkbox" checked={hasHeader} onChange={(e) => setHeader(e.target.checked)} />
        Header row
      </label>
      <select className="rounded border border-zinc-200 bg-transparent px-1 py-0.5 dark:border-zinc-700 dark:bg-zinc-950" aria-label="Delimiter" value={used} onChange={(e) => setDelimiter(e.target.value)}>
        {DELIMITERS.map((d) => (
          <option key={d.value} value={d.value}>
            {d.label}
          </option>
        ))}
      </select>
    </DataTable>
  );
}
